<template>
  <div>
    <div class="section-block">
      <font-awesome-icon icon="calendar-check" class="fa-fw" />Kalender
    </div>
    <table class="table">
      <tbody>
        <tr v-for="item in displayedFutureGames" :key="item.index">
          <td>
            <small>
              {{ item.date | formatDayName }} {{ item.date | formatDate }}
              <br />
              {{item.date | formatTime}} {{item.location}}
            </small>
          </td>
          <td class="text-left">
            <span
              v-bind:class="{ 'font-weight-bold': item.homeScore > item.outScore }"
            >{{ item.homeTeam }} ({{item.homeRank}})</span>
            <br />
            <span
              v-bind:class="{ 'font-weight-bold': item.outScore > item.homeScore }"
            >{{item.outTeam}} ({{item.outRank}})</span>
          </td>
        </tr>
      </tbody>
    </table>
    <button
      type="button"
      class="btn btn-link"
      v-if="displayShowMoreButton()"
      v-on:click="showFullCalendar()"
    >Volledige kalender tonen</button>
    <button
      type="button"
      class="btn btn-link"
      v-if="displayShowLessButton()"
      v-on:click="showLimitedCalendar()"
    >Beperkte kalender tonen</button>
  </div>
</template>

<script>
export default {
  name: "Calendar",
  props: {
    data: Array
  },
  data: function() {
    return {
      passedGames: Array,
      // futureGames: Array,
      displayedFutureGames: Array,
      displayShowMoreButton: () => Boolean,
      displayShowLessButton: () => Boolean,
      showFullCalendar: () => Boolean,
      showLimitedCalendar: () => Boolean
    };
  },
  created: function() {
    let futureGames = this.data.filter(x => !x.isPassed);
    this.passedGames = this.data.filter(x => x.isPassed);
    let limitedCalendarIndex =
      futureGames.filter(
        x =>
          this.$options.filters.formatDate(x.date) ===
          this.$options.filters.formatDate(futureGames[0].date)
      ).length * 3;
    let limitedCalendarFilter = (item, index) => index < limitedCalendarIndex;
    let limitedCalendarGames = futureGames.filter(limitedCalendarFilter);
    this.displayedFutureGames = limitedCalendarGames;
    this.displayShowMoreButton = () => {
      return this.displayedFutureGames.length < futureGames.length;
    };
    this.displayShowLessButton = () => {
      return this.displayedFutureGames.length === futureGames.length;
    };
    this.showFullCalendar = () => {
      this.displayedFutureGames = futureGames;
    };
    this.showLimitedCalendar = () => {
      this.displayedFutureGames = limitedCalendarGames;
    };
  }
};
</script>

<style scoped>
</style>
